import React from 'react';
import { Modal as MaterialModal } from '@material-ui/core';
import Button from 'src/components/Button/Button';
import { useTranslation } from 'react-i18next';

interface TransferModalProps {
  onClose: () => void,
  onApprove: () => Promise<void>,
  userId: string,
  username: string
}

function TransferModal({ onClose, userId, username, onApprove }: TransferModalProps) {
  const { t } = useTranslation();

  return (
    <MaterialModal
      disableEscapeKeyDown={ true }
      open={ true }
      onClose={ onClose }
      className="modal"
    >
      <div className="modal-container">
        <div className="cancel-ticket__modal">
          <h3 className="cancel-ticket__title">{ t('adminSession.transferFromUserToTill') }</h3>
          <h3 className="cancel-ticket__subtitle">{
            t('adminSession.transferInfo', { userId, username })
          }</h3>

          <div className="cancel-ticket__buttons">
            <Button
              type="button"
              text={ t('adminSession.submit') }
              className="btn btn--cta"
              onClick={ onApprove }
            />
            <Button
              type="button"
              text={ t('adminSession.cancelSession') }
              className="btn btn--cta cancel-ticket__button cancel-ticket__button--cancel"
              onClick={ onClose }
            />
          </div>
        </div>
      </div>
    </MaterialModal>

  );
}

export default TransferModal;
